export const loadUtmParameter = function () {

  const utmParameter = {}
  if (typeof URLSearchParams === 'undefined') {
    return utmParameter
  }

  const urlParams = new URLSearchParams(window.location.search)

  for (const it of urlParams.entries()) {
    const key = it[0];
    const value = it[1];
    if (key.indexOf('utm') !== -1) utmParameter[key.replace('utm_', '')] = Object.assign(value)
  }
  return utmParameter;
}

export const removeQueryParameter = function () {
  var clean_uri = location.protocol + "//" + location.host + location.pathname;
  window.history.replaceState({}, document.title, clean_uri);
}

export const getBrowserLanguage = () => {
  const browserLang = navigator.language.toLocaleLowerCase();
  switch (browserLang) {
    case 'de':
    case 'de-de':
      return 'de-DE';
    case 'pl':
    case 'pl-pl':
      return 'pl-PL';
    default:
      return 'en'
  }
}

export const isGenderValid = function (gender) {
  return !!gender && (gender === 'm' || gender === 'w');
}

export const isSearchGenderValid = function (searchGender) {
  return !!searchGender && (searchGender === 'm' || searchGender === 'w');
}

export const isAgeRangeValid = function (range) {
  return !!range && range.length === 2 && range[0] >= 18 && range[1] <= 99 && range[1] >= 18 && range[1] <= 99 ;
}
